var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{ref:"testNotFound"},[_c('h1',[_vm._v("404 Not Found")])])}
var staticRenderFns = []

export { render, staticRenderFns }